import { decode } from "bs58";

export default function isTrc20(address: string) {
  return address[0] === "T" && decode(address).length === 25;
}
